/**
 * A composable function that provides the scroll direction by injecting it from the dependency injection system.
 *
 * @returns {ScrollDirection} The current scroll direction.
 */
export const useScrollDirection = (): ScrollDirection => inject(injectionSymbolScrollDirection)!;
